import { UserProfile } from '@app/pages/Profile/UserProfile';
import { ConfirmOptOutDialog } from '@app/pages/Profile/ConfirmOptOut/ConfirmOptOutDialog';
import { useState } from 'react';
import { TermsAndConditionsDialog } from '@components/TermsAndConditions/TermsAndConditionsDialog';

export const ProfilePage = () => {
  const [optOutOpen, setOptOutOpen] = useState(false);
  const [showTermsDialog, setShowTermsDialog] = useState(false);
  return (
    <>
      <UserProfile onShowTermsAndConditions={() => setShowTermsDialog(true)} onOptOut={() => setOptOutOpen(true)} />
      <ConfirmOptOutDialog closeOptInDialog={() => setOptOutOpen(false)} confirmOpen={optOutOpen}></ConfirmOptOutDialog>
      <TermsAndConditionsDialog
        onClose={() => setShowTermsDialog(false)}
        open={showTermsDialog}
      ></TermsAndConditionsDialog>
    </>
  );
};
